import { Alert, AlertType } from '@design';
import { appPaths } from '@terminal/routes/app-paths';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import styles from './UpgradePrompt.module.scss';

export interface UpgradePromptProps {
  hide: boolean;
}

export const UpgradePrompt = ({ hide }: UpgradePromptProps) => {
  const { t } = useTranslation('watchlistManager');
  const navigate = useNavigate();

  if (hide) {
    return null;
  }

  return (
    <Alert
      className={styles.alert}
      variant="inline"
      type={AlertType.Warning}
      title={t('watchlistLimitReached')}
      message={t('upgradeToCreateMore')}
      primaryBtn={{
        variant: 'primary',
        onClick: () => navigate(appPaths.settings.subscription),
        label: t('upgrade'),
        size: 'large',
      }}
    />
  );
};
